export default {"src":"/_next/static/media/Twitter.bfd68ccf.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};